import React from 'react'
import PropTypes from 'prop-types'
import useStyles from './loading-screen-style'
import combineClassNames from '../../helpers/combineClassNames'

const LoadingScreenView = ({ isFixed }) => {
  const styles = useStyles()
  return (
    <div
      className={combineClassNames([
        styles.loadingScreen,
        isFixed && styles.loadingScreenFixed,
      ])}
    >
      <div className={styles.loader}> </div>
    </div>
  )
}

LoadingScreenView.propTypes = {
  isFixed: PropTypes.bool,
}

LoadingScreenView.defaultProps = {
  isFixed: true,
}
export default LoadingScreenView
